export default __webpack_public_path__ + "8e6bf37b03922a2554c3ef101a972be7.png";